import { Injectable } from '@angular/core';

@Injectable()
export class ComponentHelperService {
  findElementPositionById(arr, id) {
    if (!(arr && arr.length && id)) {
      return;
    }
    return arr
      .map(function(element) {
        return element.id;
      })
      .indexOf(id);
  }

  deleteElementById(arr, id) {
    const elementPosition = this.findElementPositionById(arr, id);
    return elementPosition >= 0 ? arr.splice(elementPosition, 1) : elementPosition;
  }
  findElementById(arr, id) {
    const elementPosition = this.findElementPositionById(arr, id);
    return elementPosition >= 0 ? arr[elementPosition] : elementPosition;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/util/component-helper.service.ts